import { render, staticRenderFns } from "./MyAggregatedReports.vue?vue&type=template&id=2f90d59b&scoped=true"
import script from "./MyAggregatedReports.vue?vue&type=script&lang=js"
export * from "./MyAggregatedReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f90d59b",
  null
  
)

export default component.exports